<template>
  <div class="not-form">
    <div class="not-form__body">
      <div class="not-form__heading">占いたいこと</div>
      <ul class="uranai-list">
        <li
          class="uranai-list__item"
          v-for="item in formSetting.themeq.items"
          :key="item.label"
          :style="'background-image: url(/static/img/favor/kantei_' + item.id + '.jpg)'"
        >
          <span class="uranai-list__text">{{ item.value }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntryKanteiNotForm",
  props: {
    formSetting: {
      type: Object,
      default () {
        return {}
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.not-form {
  color: $col_base_black;
  &__body {
    padding: 30px 10px 0;
  }
  &__heading {
    font-weight: bold;
    font-size: 18px;
    margin: 0 0 15px;
  }
}
.uranai-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: -5px;
  &__item {
    $width: calc(33.33% - 10px);
    display: block;
    flex: 1 1 $width;
    max-width: $width;
    background: no-repeat 50% 50%/contain;
    padding-bottom: $width;
    margin: 5px;
    border-radius: 100px;
    overflow: hidden;
    position: relative;
  }
  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    font-weight: bold;
    font-size: 17px;
    color: #fff;
    text-align: center;
    text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/EntryKanteiNotForm.vue